import { isUndefined } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { SaveFile } from '../icons';
import { LongText } from '../longtext/LongText';
import { ConfirmationModal } from '../modal/ConfirmationModal';
import { ModalHeader } from '../modal/ModalHeader';
import { Text } from '../text/Text';

interface SaveReportTemplateModalProps {
    isOpen: boolean;
    closeModal: () => void;
    save: (saveAs: boolean) => void;
    name: string;
    description: string;
    updateName: (name: string) => void;
    updateDescription: (description: string) => void;
    templateId: number | undefined;
    testId: string;
}

export const SaveReportTemplateModal: React.FC<SaveReportTemplateModalProps> = ({ isOpen, closeModal, save, name, description, updateName, updateDescription, templateId, testId }) => {
    const saveDisabled = useMemo(() => name.length === 0, [name.length]);
    const saveDisabledTooltip = useMemo(() => saveDisabled ? ['Report template must have a name'] : [], [saveDisabled]);
    const saveTemplate = useCallback(() => save(!isUndefined(templateId)), [save, templateId]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            closeModal={closeModal}
            confirm={saveTemplate}
            confirmDisabled={saveDisabled}
            confirmDisabledTooltip={saveDisabledTooltip}
            confirmLabel='Save'
            testId={`save-report-template-${testId}`}
        >
            <ModalHeader label='Save Report Template' icon={SaveFile} testId={`save-report-template-${testId}`} />
            <Text
                testId={`save-report-template-${testId}-name`}
                label='Template Name'
                value={name}
                onChange={e => updateName(e.target.value)}
                maxLength={100}
            />
            <LongText
                testId={`save-report-template-${testId}-description`}
                label='Description'
                value={description}
                onChange={updateDescription}
                width='500px'
            />
        </ConfirmationModal>
    );
};
